// eslint-disable-next-line @typescript-eslint/no-explicit-any
import config from 'config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let request: Promise<(...args: any[]) => any> | null = null;

const load = () => {
    if (!request) {
        request = new Promise((resolve, reject) => {
            if (document.getElementById('stream-player-sdk')) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                resolve((window as any).StreamPlayer.createPlayer);
                return;
            }

            const script = document.createElement('script');
            script.id = 'stream-player-sdk';
            script.src = config.streamPlayer.src;
            script.async = true;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            script.onload = () => resolve((window as any).StreamPlayer.createPlayer);
            script.onerror = (err) => reject(err);
            document.head.appendChild(script);
        });
    }

    return request;
};

export default load;
